import { useSubscribe } from "@booking/hooks/usePubSub";
import { FILTER_CONTEXTS } from "@search/api/constants";
import DropdownFacet from "@search/components/DropdownFacet";
import { FilterSet } from "@search/store/FilterSet";
import { Filters } from "@search/store/types";
import { useNavigate } from "react-router-dom";

import { DropdownInputEventEnum } from "@/components/compounds/forms/DropdownInput";
import type { CommonProps, PubSubData } from "@/types";
import { createId } from "@/utils/helpers";

const ref = "sort-filter";

interface SortFilterProps extends Partial<CommonProps> {
  filters: Filters;
}

function useSortFilter(props: SortFilterProps) {
  const filterSet = new FilterSet(props.filters);
  const { id = createId(ref) } = props;

  return {
    filterSet,
    id: `${id}_${FILTER_CONTEXTS.sort}`,
    options: filterSet.sortFilter.options(),
    selectedValue: filterSet.getSort(),
  };
}

function SortFilter(props: SortFilterProps) {
  const { filterSet, id, options, selectedValue } = useSortFilter(props);
  const navigate = useNavigate();

  function updateDropDownControl(data: PubSubData) {
    switch (data.context) {
      case FILTER_CONTEXTS.sort: {
        const newQuery = filterSet.applySort(data.value);
        navigate(newQuery);

        break;
      }
    }
  }

  useSubscribe(
    DropdownInputEventEnum.SELECTED_INDEX_CHANGE,
    updateDropDownControl,
  );

  return (
    <DropdownFacet
      id={id}
      label={"Sort by"}
      name={FILTER_CONTEXTS.sort}
      noWrap
      options={options}
      selectedValue={selectedValue}
      eventGroup="Filters"
    />
  );
}

export default SortFilter;
export { SortFilter, type SortFilterProps };
